import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon_add",
  "use": "icon-icon_add-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon_add\">\n  <path d=\"M972.8 563.2H563.2v409.6c0 28.262-22.938 51.2-51.2 51.2-28.262 0-51.2-22.938-51.2-51.2V563.2H51.2C22.938 563.2 0 540.262 0 512c0-28.262 22.938-51.2 51.2-51.2h409.6V51.2C460.8 22.938 483.738 0 512 0c28.262 0 51.2 22.938 51.2 51.2v409.6h409.6c28.262 0 51.2 22.938 51.2 51.2 0 28.262-22.938 51.2-51.2 51.2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/user/icons/svg/icon_add.svg
// module id = gmiZ
// module chunks = 12